// This page is dedicated to displaying the webinars schedule only.
// It uses the 'confirencesAndSeminars' category for the API request,
// but always uses the 'webinarsSchedule' translation key for UI and breadcrumbs.
// Do not mix this with the generic news article/category logic.
import { Box } from "@material-ui/core";
import Breadcrumbs from "components/Breadcrumbs";
import Link from "components/Link";
import NoDataAvailable from "components/NoDataAvailable";
import SEO from "components/SEO";
import SessionContext from "components/session/SessionContext";
import Text from "components/Text";
import { pagePadding } from "data/commonClasses";
import { fetchFromAPI, getTranslationContent, isArray } from "functions";
import Image from "next/image";
import { useContext, useEffect, useState } from "react";
import useStyles from "styles/News.Style";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

export default function WebinarsSchedule(props) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { session: { lang } = { lang: "en" } } =
    useContext(SessionContext) || {};
  let isAr = lang === "ar";

  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let reqBody = {
      limit: 3,
      page: 1,
      category: "confirencesAndSeminars", // API expects this value
      lang,
    };
    fetchFromAPI({ api: "news", reqBody }).then((response) => {
      // console.log("[WebinarsSchedule] API response:", response); // Debug log
      let news = response?.response?.news;
      setNews(news);
      setLoading(false);
    });
  }, [lang]);

  var breadcrumbs = [
    { text: t("home"), href: "/" },
    { text: t("webinarsSchedule") },
  ];

  return (
    <div className={twMerge("flex flex-col w-full min-h-screen", pagePadding)}>
      <SEO title={t("webinarsSchedule")} description={t("webinarsSchedule")} />
      <Breadcrumbs items={breadcrumbs} />
      <Text text={t("webinarsSchedule")} bold sectionTitle className="mt-5" />
      <div className={"bg-lightGrey p-5 rounded-button my-5"}>
        {loading ? (
          <Text text={t("loading")} />
        ) : !isArray(news) || news.length === 0 ? (
          <NoDataAvailable />
        ) : (
          <div
            className={
              "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 place-items-start gap-5"
            }
          >
            {news.map((newsItem) => (
              <Link
                href="/webinarsSchedule/details/[slug]"
                as={`/webinarsSchedule/details/${newsItem.slug}`}
                key={newsItem._id}
              >
                <a>
                  <div className="w-full flex flex-col ">
                    <div className={"mb-5 aspect-square"}>
                      <Image
                        src={
                          newsItem.image
                            ? `${newsItem.image}`
                            : "/placeholder.jpg"
                        }
                        alt="News Image"
                        layout="intrinsic"
                        objectFit="cover"
                        className="aspect-square"
                        height={480}
                        width={480}
                        style={{
                          borderRadius: "12px",
                          borderWidth: "2px",
                          borderColor: "#E8E3CF",
                          borderStyle: "solid",
                        }}
                      />
                    </div>
                    <Text
                      className="text-ellipsis line-clamp-3 max-w-72 md:max-w-96"
                      bold
                      subtitle
                      text={getTranslationContent(newsItem, "title", lang)}
                    />
                  </div>
                </a>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
